if (typeof Presun_Zadosti === 'undefined') {

    var Presun_Zadosti = {

        init: function () {
            var tlacitko = $('#tlacitko-hromadny-presun-zadosti');
            if (!tlacitko.length) {
                return;
            }

            tlacitko
                .off('click')
                .on('click', function (e) {
                    e.preventDefault();

                    var grid = $('#grid_section_i103');
                    var rows = $(grid).jqGrid('getGridParam', 'selarrrow');
                    if (!rows.length) {
                        Lemo_Alert.addInfo('Pro přesun označte alespoň jednu žádost', 'presunZadostiInfo');
                        return;
                    }

                    var ids = [];
                    $.each(rows, function (i, id) {
                        ids.push(id);
                    });

                    $.ajax({
                        type: 'post',
                        url: '/plugin/PluginZadost/presunZadostiFormularAjax',
                        dataType: 'json',
                        data: {'ids': ids},
                        global: false,
                        beforeSend: function () {
                            Lemo_Alert.closeAll();
                            Lemo_Alert.addInfo('Načítám formulář ...', 'presunZadostiFormular');
                        },
                        complete: function () {
                            Lemo_Alert.closeById('presunZadostiFormular');
                        },
                        success: function (data) {
                            Lemo_Alert.addMany(data.messages);
                            if (
                                false === data['status']
                                || !data.hasOwnProperty('html')
                                || !data['html'].length
                            ) {
                                return;
                            }

                            // modal
                            Lemo_Modal.setSize('large');
                            Lemo_Modal.setTitle('Přesun žádostí do jiného dotačního titulu');
                            Lemo_Modal.setContent(data.html);
                            Lemo_Modal.addButton('continue', 'Pokračovat', 'btn btn-primary', function () {
                                Lemo_Alert.closeAll();
                                Presun_Zadosti.akce($('#modal-titul').val());
                                Lemo_Modal.close();
                            });
                            Lemo_Modal.addButton('cancel', 'Zrušit', 'btn btn-default', function () {
                                Lemo_Alert.closeAll();
                                Lemo_Modal.close();
                            });
                            Lemo_Modal.build();

                            Presun_Zadosti.initAutocomplete();
                        }
                    });
                });
        },

        initAutocomplete: function () {
            var titulAutocomplete = $('#modal-titul-autocomplete');
            if (!titulAutocomplete.length) {
                Lemo_Modal.close();
                Lemo_Alert.addDanger('Nepodařilo se inicializovat formulář', 'presunZadostiFormularError');
                return;
            }

            titulAutocomplete.autocomplete({
                autofocus: true,
                minLength: 0,
                global: false,
                delay: 2000,
                source: function (request, response) {
                    $.ajax({
                        url: '/plugin/PluginZadost/presunZadostiAutocompleteAjax',
                        dataType: 'json',
                        type: 'post',
                        data: {'dotacniTitul': titulAutocomplete.val()},
                        success: function (r) {

                            var buttonSubmit = $('#dialogButtons').find('.btn-primary');
                            buttonSubmit.attr('disabled', true).prop('disabled', true);
                            var titul = $('#modal-titul');
                            titul.val('');

                            if (r.hasOwnProperty('data')) {
                                if (!r.data.length) {
                                    Lemo_Alert.addDanger('Dotační titul nenalezen', 'autocomplete');
                                }
                                response(r.data);
                            }
                        }
                    });
                },
                select: function (e, ui) {
                    e.preventDefault();
                    Lemo_Alert.closeById('autocomplete');
                    var titul = $('#modal-titul');
                    var buttonSubmit = $('#dialogButtons').find('.btn-primary');

                    if (ui.item !== null) {
                        $(this).val(ui.item.label);
                        titul.val(ui.item.id);
                        buttonSubmit.attr('disabled', false).prop('disabled', false);
                    }
                }
            });
        },

        /**
         * @param {number} titulId
         */
        akce: function (titulId) {
            var grid = $('#grid_section_i103');
            var rows = $(grid).jqGrid('getGridParam', 'selarrrow');
            if (!rows.length) {
                return;
            }

            var ids = [];
            $.each(rows, function (i, id) {
                ids.push(id);
            });

            var odeslatEmail = $('#modal-odeslat-email:checked').length;
            var textEmail = $('#modal-zprava').val();

            var progressId = 'presun-zadosti-' + Math.round(new Date().getTime() + (Math.random() * 100));

            $.ajax({
                type: 'post',
                url: '/plugin/PluginZadost/presunZadostiAjax',
                dataType: 'json',
                global: true,
                data: {'progressId': progressId, 'titulId': titulId, 'ids': ids, 'odeslatEmail': odeslatEmail, 'textEmail': textEmail},
                beforeSend: function () {
                    var text = '<p id="export-progress-eta">Příprava operace ...</p>';
                    text += '<div id="export-progress" class="progress text-center mb-3">';
                    text += '    <div class="progress-bar progress-bar-animated active" role="progressbar" style="width: 0;">0%</div>';
                    text += '</div>';
                    text += '<p id="export-progress-message" class="text-monospace"></p>';

                    Lemo_Alert.setShowCloseButton(false);
                    Lemo_Alert.setCloseOnClick(false);
                    Lemo_Alert.build('info', 'Přesun žádostí do jiného titulu', text, 'ajaxProgress', 0);
                    Lemo_Alert.setShowCloseButton(true);
                    Lemo_Alert.setCloseOnClick(true);

                    Plugin_Zadost.progressInterval = window.setInterval(function() {
                        Plugin_Zadost.ajaxProgress(progressId);
                    }, 2500);

                },
                complete: function () {
                    Lemo_Alert.closeById('ajaxProgress');
                    if (null !== Plugin_Zadost.progressInterval) {
                        window.clearInterval(Plugin_Zadost.progressInterval);
                        Plugin_Zadost.progressInterval = null;
                    }
                },
                success: function (data) {
                    if (data.hasOwnProperty('messages')) {
                        Lemo_Alert.addMany(data.messages);
                    }

                    var grid = $('#grid_section_i103');
                    grid.trigger('reloadGrid');
                }
            });
        },
    };
}

$(document)
    .ready(function () {
        Presun_Zadosti.init();
    });